export default "__VITE_ASSET__Bpsil8_s__"